import React from "react";
import { Box, Stack, styled, Typography } from "@mui/material";

const StyledBox = styled(Box)`
  position: relative;
  flex-direction: column;
`;

const StyledStack = styled(Stack)`
  position: absolute;
  gap: 15px;
  top: 0;
  right: 20px;
`;

const UserPrivilegeDisplay = ({
  user,
}) => {
  return (
    <StyledBox>
      <StyledStack direction={{ sm: "row" }}>
        {user.administrator ? (
          <Typography variant="overline">
            Admin
          </Typography>
        ) : (
          <Typography variant="overline">
            No Privileges
          </Typography>
        )}
      </StyledStack>
    </StyledBox>
  );
};

export default UserPrivilegeDisplay;
